import axios from 'axios'
import {get} from 'lodash'
import User from './User.class'

const baseURL = '/api/role/'

export default class Role {
	constructor (init) {
		this.id = get(init, 'id') ? init.id : null
		this.guard_name = get(init, 'guard_name') ? init.guard_name : ''
		this.name = ''
		this.permissions = get(init, 'permissions')

		if (get(init, 'name')) {
			this.name = init.name
			this.nameInit = init.name
		}

		this.translate = get(init, 'translate', this.name)
	}

	static url = baseURL

	static getAll (params) {
		return axios.get(baseURL, {
			params
		})
			.then(res => {
				return {
					...res.data,
					data: res.data.data.map(item => new Role(item))
				}
			})
			.catch(err => {
				console.error(err)
				return null
			})
	}

	static getAllPermissions (params) {
		return axios.get('/api/permission/', {
			params
		})
			.then(res => {
				return {
					...res.data,
					data: res.data.data
				}
			})
			.catch(err => {
				console.error(err)
				return null
			})
	}

	static attachDetach (id, formData) {
		return axios.post(`${baseURL}${id}`, formData)
			.then(({data}) => {
				console.log(data)
			})
	}

	changeUsers (arr = [], status) {
		const formData = new FormData()
		arr.forEach(item => {
			formData.append(`user[${item.id}]`, status)
		})

		return axios.post(`${baseURL}${this.id}`, formData)
			.then(res => {
				return res
			})
			.catch(err => {
				console.error(err)
				return false
			})
	}

	static getRoleUsers (params) {
		return axios.get(`/api/users/role`, {
			params
		})
			.then(res => {
				return {
					...res.data,
					data: res.data.data.map(item => new User(item))
				}
			})
			.catch(err => {
				console.error(err)
				return null
			})
	}

	/**
	 * @param {String} role
	 * @return Boolean
	 */
	isRole (role) {
		return this.nameInit === role || this.name === role
	}
}



// WEBPACK FOOTER //
// ./src/assets/js/Role.class.js